import React, { useState } from 'react';
import { toast } from 'sonner';
import { CheckCircle2 } from 'lucide-react';
import { Button } from '../ui/button';
import axiosInstance from '../../api/axios';

const METHOD_LABELS = { stripe: 'Karte (Stripe)', paypal: 'PayPal', bank_transfer: 'Überweisung' };

export const OrderPaymentStatus = ({ order, onPaid }) => {
  const [busy, setBusy] = useState(false);
  const paid = order.payment_status === 'paid';

  const markPaid = async () => {
    if (!window.confirm(`Zahlung für Bestellung ${order.order_number || ''} als erhalten markieren? Der Kunde bekommt eine Bestätigung per E-Mail.`)) return;
    setBusy(true);
    try {
      const { data } = await axiosInstance.post(`/orders/admin/${order.id}/mark-paid`);
      toast.success(data.email_sent ? 'Als bezahlt markiert – Kunde per E-Mail informiert' : 'Als bezahlt markiert (E-Mail konnte nicht gesendet werden)');
      onPaid?.();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Fehler beim Markieren');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="order-payment-block">
      <p className="text-sm font-medium mb-1">Zahlung</p>
      <div className="flex flex-wrap items-center gap-2">
        <span className="text-sm text-gray-600">{METHOD_LABELS[order.payment_method] || order.payment_method || '—'}</span>
        <span
          data-testid="admin-order-payment-status"
          className={`px-2 py-0.5 text-xs font-medium ${paid ? 'bg-green-100 text-green-800' : 'bg-amber-100 text-amber-800'}`}
        >
          {paid ? 'Bezahlt' : 'Zahlung ausstehend'}
        </span>
        {!paid && (
          <Button
            size="sm"
            onClick={markPaid}
            disabled={busy}
            className="rounded-none bg-[#C4A484] hover:bg-[#B89968]"
            data-testid="mark-order-paid-btn"
          >
            <CheckCircle2 className="h-4 w-4 mr-1" />
            {busy ? 'Speichert…' : 'Zahlung erhalten'}
          </Button>
        )}
      </div>
    </div>
  );
};
